<template>
  <div id = "siruq">
    <div id = "intro">
      <a href="#/intro">しるQとは？<v-fa :icon="['fas', 'external-link-alt']" /></a>
    </div>
    <Question/>
    <AnswerBtn/>
    <Twitter/>
    <AnswerBtn/>
  </div>
</template>

<script>
import Question from './Question'
import AnswerBtn from './AnswerBtn'
import Twitter from './Twitter'
export default {
  name: 'Index',
  components : {
    Question,
    AnswerBtn,
    Twitter
  },
  data () {
    return {
      msg: '今日の質問',
      question: 'ああああああああああああああああああああ'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #intro{
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue